import BankingTransitionLayout from './BankingTransitionLayout';

export default BankingTransitionLayout;
